// The fixture label's two teams ("Home v Away" → ["Home", "Away"]).
//
// One rule shared by the team toggle (its options) and the widget context (the
// team a widget is handed), so the two can never disagree. WHY it matters: a
// module's team pick is saved by NAME, and a saved board doesn't store the match
// — so a board saved on Newcastle v Everton and reopened on Man Utd v Man City
// still holds "Newcastle United". The toggle already fell back to the home team,
// but the widget got the stale name and showed "No data" (Prateek, 2026-11-02).

/** The fixture's teams, home first. */
export function fixtureTeams(fixture: string): string[] {
  return fixture.split(" v ").filter(Boolean);
}

/** The saved team if it's playing in this fixture, else null (= the widget's
 *  default, the home team — the same side the toggle shows). */
export function teamInFixture(team: string | null | undefined, fixture: string): string | null {
  return team != null && fixtureTeams(fixture).includes(team) ? team : null;
}
